import { createContext } from 'react';

import Authentication from '../services/authentication';

export const AuthenticationContext = createContext<Authentication | undefined>(undefined);

export const AuthenticationProvider = AuthenticationContext.Provider;
